module.exports = __webpack_public_path__ + "img/ai_resize.c8c2a6f.png";